import createRenderer from './createRenderer';
import StyleProvider from './StyleProvider';

var isProd = process.env.NODE_ENV === 'production';
var felaSnapshot = isProd ? null : require('./felaSnapshot').default;
var felaTestContext = isProd ? null : require('./felaTestContext').default;

export { createRenderer, StyleProvider, felaTestContext, felaSnapshot };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-provider/es/index.js
// module id = 932
// module chunks = 1